import { defineStore } from 'pinia'
import type { RoutineState, RoutineMetaData } from '@/types/routine-types'

export const useRoutinesStore = defineStore('routines', {
  state: (): RoutineState => ({
    metaData: {
      weeks: '',
      minutes: '',
      minutesMin: '',
      minutesMax: '',
      daysWeek: '',
      difficulty: 0,
      bodyFocus: '',
      equipment: '',
      trainingType: '',
    },
  }),

  getters: {
    // no-op
  },

  actions: {
    // update meta data
    setMetaData(metaData: RoutineMetaData) {
      this.metaData = {
        ...metaData,
      }
    },
  },
})
